/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModeCalculTarification } from './ModeCalculTarification';
import {
    ModeCalculTarificationFromJSON,
    ModeCalculTarificationFromJSONTyped,
    ModeCalculTarificationToJSON,
    ModeCalculTarificationToJSONTyped,
} from './ModeCalculTarification';
import type { ModeCalculFraisParc } from './ModeCalculFraisParc';
import {
    ModeCalculFraisParcFromJSON,
    ModeCalculFraisParcFromJSONTyped,
    ModeCalculFraisParcToJSON,
    ModeCalculFraisParcToJSONTyped,
} from './ModeCalculFraisParc';

/**
 * Configuration parc d'un frais du tunnel (branches parcables GLI / CBNO).
 * @export
 * @interface FraisParcConfigItemDto
 */
export interface FraisParcConfigItemDto {
    /**
     * 
     * @type {string}
     * @memberof FraisParcConfigItemDto
     */
    remunerationTunnelId: string;
    /**
     * 
     * @type {string}
     * @memberof FraisParcConfigItemDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FraisParcConfigItemDto
     */
    natureCode?: string | null;
    /**
     * 
     * @type {ModeCalculFraisParc}
     * @memberof FraisParcConfigItemDto
     */
    modeCalcul?: ModeCalculFraisParc;
    /**
     * 
     * @type {number}
     * @memberof FraisParcConfigItemDto
     */
    montantParc?: number | null;
    /**
     * 
     * @type {ModeCalculTarification}
     * @memberof FraisParcConfigItemDto
     */
    modeMontantParc?: ModeCalculTarification;
    /**
     * false = aucune décision enregistrée, le comportement par défaut s'applique.
     * @type {boolean}
     * @memberof FraisParcConfigItemDto
     */
    estExplicite?: boolean;
    /**
     * Ligne verrouillée — le back gère seul le montant du courtier connecté.
     * @type {boolean}
     * @memberof FraisParcConfigItemDto
     */
    isCourtierConnecte?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FraisParcConfigItemDto
     */
    isFraisVariable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FraisParcConfigItemDto
     */
    montantUnitaire?: number | null;
    /**
     * 
     * @type {ModeCalculTarification}
     * @memberof FraisParcConfigItemDto
     */
    modeCalculTarif?: ModeCalculTarification;
    /**
     * 
     * @type {number}
     * @memberof FraisParcConfigItemDto
     */
    taux?: number | null;
}



/**
 * Check if a given object implements the FraisParcConfigItemDto interface.
 */
export function instanceOfFraisParcConfigItemDto(value: object): value is FraisParcConfigItemDto {
    if (!('remunerationTunnelId' in value) || value['remunerationTunnelId'] === undefined) return false;
    return true;
}

export function FraisParcConfigItemDtoFromJSON(json: any): FraisParcConfigItemDto {
    return FraisParcConfigItemDtoFromJSONTyped(json, false);
}

export function FraisParcConfigItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraisParcConfigItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remunerationTunnelId': json['remunerationTunnelId'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'natureCode': json['natureCode'] == null ? undefined : json['natureCode'],
        'modeCalcul': json['modeCalcul'] == null ? undefined : ModeCalculFraisParcFromJSON(json['modeCalcul']),
        'montantParc': json['montantParc'] == null ? undefined : json['montantParc'],
        'modeMontantParc': json['modeMontantParc'] == null ? undefined : ModeCalculTarificationFromJSON(json['modeMontantParc']),
        'estExplicite': json['estExplicite'] == null ? undefined : json['estExplicite'],
        'isCourtierConnecte': json['isCourtierConnecte'] == null ? undefined : json['isCourtierConnecte'],
        'isFraisVariable': json['isFraisVariable'] == null ? undefined : json['isFraisVariable'],
        'montantUnitaire': json['montantUnitaire'] == null ? undefined : json['montantUnitaire'],
        'modeCalculTarif': json['modeCalculTarif'] == null ? undefined : ModeCalculTarificationFromJSON(json['modeCalculTarif']),
        'taux': json['taux'] == null ? undefined : json['taux'],
    };
}

export function FraisParcConfigItemDtoToJSON(json: any): FraisParcConfigItemDto {
    return FraisParcConfigItemDtoToJSONTyped(json, false);
}

export function FraisParcConfigItemDtoToJSONTyped(value?: FraisParcConfigItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remunerationTunnelId': value['remunerationTunnelId'],
        'libelle': value['libelle'],
        'natureCode': value['natureCode'],
        'modeCalcul': ModeCalculFraisParcToJSON(value['modeCalcul']),
        'montantParc': value['montantParc'],
        'modeMontantParc': ModeCalculTarificationToJSON(value['modeMontantParc']),
        'estExplicite': value['estExplicite'],
        'isCourtierConnecte': value['isCourtierConnecte'],
        'isFraisVariable': value['isFraisVariable'],
        'montantUnitaire': value['montantUnitaire'],
        'modeCalculTarif': ModeCalculTarificationToJSON(value['modeCalculTarif']),
        'taux': value['taux'],
    };
}

